export default __webpack_public_path__ + "static/ToyotaUsedCars_vert_black-fe847e7c491136215fa6a813de8761eb.png";